import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { ManagementGrid } from '@/routes/admin/components/ManagementGrid/ManagementGrid'
import { ManagementGridExtendedColumn } from '@/routes/admin/components/ManagementGrid/types'
import { DataGridTypes } from 'devextreme-react/data-grid'
import { ReferencesV2 } from '@/routes/admin/components/ManagementGrid/ReferencesV2'
import { qqs_supporto_applicazione } from '@/model/qsadminapi/QQsAdminApiModule'
import { createQueryBuilderV4 } from '@odata2ts/odata-query-builder'
import { ColumnCellTemplateData } from 'devextreme/ui/data_grid'

const columns: ManagementGridExtendedColumn[] = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    allowEditing: false,
    width: 60,
  },
  {
    dataField: 'nome',
    caption: 'Nome',
    dataType: 'string',
    allowEditing: true,
  },
  {
    dataField: 'note',
    caption: 'Note',
    dataType: 'string',
    allowEditing: true,
  },
  {
    caption: 'Argomenti Problemi',
    dataType: 'object' as DataGridTypes.DataType,
    allowEditing: false,
    allowSorting: false,
    cellRender: (cell: ColumnCellTemplateData) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return React.useMemo(() => {
        const builder = createQueryBuilderV4('qs_supporto_applicazione', qqs_supporto_applicazione)
        return (
          cell.data.id && (
            <ReferencesV2
              query={builder
                .select('argomenti_problemi')
                .filter(qqs_supporto_applicazione.id.eq(cell.data.id))
                .expanding('argomenti_problemi', (q) => q.select('id', 'nome'))
                .build()}
              keyField={'id'}
              displayField={'nome'}
              dataField={'argomenti_problemi'}
              maxCount={4}
            />
          )
        )
      }, [cell.data.id])
    },
  },
  {
    caption: 'Tickets',
    dataType: 'object' as DataGridTypes.DataType,
    allowEditing: false,
    allowSorting: false,
    cellRender: (cell: ColumnCellTemplateData) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return React.useMemo(() => {
        const builder = createQueryBuilderV4('qs_supporto_applicazione', qqs_supporto_applicazione)
        return (
          cell.data.id && (
            <ReferencesV2
              query={builder
                .select('argomenti_problemi')
                .filter(qqs_supporto_applicazione.id.eq(cell.data.id))
                .expanding('tickets', (q) => q.select('id', 'ded_Dis'))
                .build()}
              dataField={'tickets'}
              keyField={'id'}
              displayField={'ded_Dis'}
              maxCount={4}
            />
          )
        )
      }, [cell.data.id])
    },
  },
]

export const QSSupportApplicationRoute: TileRoleRoute = {
  path: 'qssupportapplications',
  text: 'Applicazioni Supporto QS',
  faIcon: faLaptopCode,
  element: (
    <div className="content-block dx-card wide-card">
      <ManagementGrid
        endpoint={`${import.meta.env.VITE_QSADMINAPI_HOST}/qs_supporto_applicazione`}
        title={`Applicazioni Supporto QS`}
        columns={columns}
        expandRelations={[]}
        storageKey={`qs_supporto_applicazione-state-management-grid`}
        defaultPageSize={20}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      />
    </div>
  ),
  handle: {
    crumb: () => ({
      label: 'Applicazioni Supporto QS',
      icon: faLaptopCode,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
